import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "star-active",
  "use": "star-active-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol viewBox=\"0 0 16 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"star-active\"><path d=\"M8 12l-4.702 2.472.898-5.236L.392 5.528l5.257-.764L8 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol